import { reatomAsync, withAbort } from "@reatom/async";
import { BuyerOrderFilterType } from "definitions/poizon-api";
import { API } from "src/api";
import { withIsLoadingAtom } from "src/common/pipes";
import { toastHandler } from "src/util";

import { OrderFilterStatus } from "../../widgets/PoizonOrderFilterWidget/PoizonOrderList.contants";
import { clientIdAtom } from "../atoms/clientId";
import {
  lastIdAtom,
  lastOrderListAtom,
  orderListAtom,
} from "../atoms/orderList";
import { poizonFilterAtom } from "../atoms/poizonFilterAtom";
import { DEFAULT_PAGE_SIZE } from "../constants";

export const getPoizonBuyerOrderList = reatomAsync(
  async (
    ctx,
    clientId: string,
    type: BuyerOrderFilterType = OrderFilterStatus.ALL,
    lastId?: string,
    keyword?: string,
    limit: number = DEFAULT_PAGE_SIZE,
  ) => {
    return API.poizonPublicApi
      .dewuControllerBuyerOrderList(clientId, limit, type, lastId, keyword, {
        signal: ctx.controller.signal,
      })
      .then((d) => d.data);
  },
  "getPoizonBuyerOrderList",
).pipe(withAbort());

export const loadMoreOrderList = reatomAsync(async (ctx) => {
  const clientId = ctx.get(clientIdAtom);
  if (!clientId) {
    toastHandler.error({
      name: "Ошибка",
      content: "Клиент не найден",
    });
    return;
  }
  const { type, keyword } = ctx.get(poizonFilterAtom);
  const lastId = ctx.get(lastIdAtom);
  const currentList = ctx.get(orderListAtom);
  const data = await getPoizonBuyerOrderList(
    ctx,
    clientId,
    type,
    lastId,
    keyword,
  );
  lastIdAtom(ctx, data.lastId);
  lastOrderListAtom(ctx, data.orderList);

  if (data.lastId) orderListAtom(ctx, [...currentList, ...data.orderList]);
}, "loadMoreOrderList").pipe(withIsLoadingAtom());
